//
// Generated class QuotationDocumentLine
//

/// <reference path="QuotationDocumentLine_ManagedObject.ts" />

class QuotationDocumentLine extends QuotationDocumentLine_ManagedObject
{

}
